<template>
  <div v-if="activities && activities.length" class="our-activity-section">
    <div class="app-container">
      <!-- Section Title -->
      <h2 class="section-title">Rangkaian Kegiatan</h2>
      
      <!-- Feature Items -->
      <div class="row">
        
        <div class="col-md-6 ">
          <div v-for="(activity, index) in activities" :key="index" class="activity-item mb-4">
            <div class="activity-item-content">
              <h5>{{ activity.name }}</h5>
              <p>{{ activity.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OurActivity',
  props: {
      activities: {
        type: Object,
        required: true,
      },
    },
};
</script>

<style scoped>
/*
 * Warna di berkas ini dulu dipaku (#181818, #000, #fff, dst), sehingga
 * bagian halaman ini TETAP GELAP walau pengguna memilih tema terang —
 * dan tetap terang di bagian lain, jadi satu halaman terlihat separuh
 * gelap separuh terang. Sekarang semuanya membaca variabel tema, jadi
 * ikut berganti bersama sisa situs.
 */

.our-activity-section {
  padding: 50px 0;
  background-color: var(--bg-surface);
}

.section-title {
  text-align: center;
  font-size: 2rem;
  font-family: var(--font-display);
  margin-bottom: 30px;
  color: var(--text-primary);
}

.text-center {
  text-align: center;
  font-size: 1rem;
  color: var(--text-secondary);
  margin-bottom: 40px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.activity-item {
  position: relative;
  background-color: var(--bg-surface);
  overflow: hidden;
  min-height: 160px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top: 2px solid var(--success-500);
}

.activity-item-content {
  padding: 20px;
  background-color: var(--bg-surface);
  /*
   * Teks di atas permukaan HARUS memakai --text-primary, bukan
   * --text-inverse. Nilai aslinya dulu 'white', dan penggantian massal
   * memetakannya ke --text-inverse tanpa melihat latarnya: di mode terang
   * itu berarti putih di atas permukaan putih — tulisannya hilang sama
   * sekali. --text-inverse hanya benar di atas warna pekat seperti tombol
   * merah di bawah.
   */
  color: var(--text-primary);
}

.activity-item-content h5 {
  font-family: var(--font-display);
  font-size: 1.6rem;
  margin-bottom: 10px;
  color: var(--text-primary);
}

.activity-item-content p {
  font-family: var(--font-sans);
  font-size: 1rem;
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .activity-item-content h5 {
    font-size: 1.4rem;
  }

  .activity-item-content p {
    font-size: 0.9rem;
  }
}
</style>
